import { render, staticRenderFns } from "./ReportReminder.vue?vue&type=template&id=93256cda&"
import script from "./ReportReminder.vue?vue&type=script&lang=js&"
export * from "./ReportReminder.vue?vue&type=script&lang=js&"
import style0 from "./ReportReminder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports